import { Component } from '@angular/core'
import { DataMap } from '@grapecity/wijmo.grid'
import { NgbNav, NgbNavContent, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase, NgbNavOutlet } from '@ng-bootstrap/ng-bootstrap'

import {
    BaseComponent,
    EquipmentBattery,
    EquipmentBrakes,
    EquipmentFilter,
    EquipmentFluidCapacity,
    EquipmentGet,
    EquipmentTireConfig,
    FeatureType,
    FLUID_COMPARTMENTS,
    ListItem,
} from '../../shared'
import { buildEquipmentLookup, formatEquipmentDisplay, PartsFluidsEquipmentContext, VpEquipmentRow } from './parts-fluids-equipment-context'
import { EquipmentBatteryListComponent } from './equipment-battery-list.component'
import { EquipmentBrakesListComponent } from './equipment-brakes-list.component'
import { EquipmentFilterListComponent } from './equipment-filter-list.component'
import { EquipmentGetListComponent } from './equipment-get-list.component'
import { EquipmentTireConfigListComponent } from './equipment-tire-config-list.component'
import { FluidCapacityListComponent } from './fluid-capacity-list.component'

@Component({
    templateUrl: './parts-fluids.component.html',
    standalone: true,
    imports: [
        NgbNav,
        NgbNavContent,
        NgbNavItem,
        NgbNavItemRole,
        NgbNavLink,
        NgbNavLinkBase,
        NgbNavOutlet,
        FluidCapacityListComponent,
        EquipmentGetListComponent,
        EquipmentBatteryListComponent,
        EquipmentBrakesListComponent,
        EquipmentFilterListComponent,
        EquipmentTireConfigListComponent,
    ],
})
export class PartsFluidsComponent extends BaseComponent implements PartsFluidsEquipmentContext {
    activeTab = 1
    fluidCompartments = FLUID_COMPARTMENTS
    equipmentOptions: ListItem<string>[] = []
    equipmentDataMap = new DataMap([], 'key', 'display')
    equipmentDisplayByCode = new Map<string, string>()
    fluidCapacities: EquipmentFluidCapacity[] = []
    equipmentGets: EquipmentGet[] = []
    equipmentBatteries: EquipmentBattery[] = []
    equipmentBrakes: EquipmentBrakes[] = []
    equipmentFilters: EquipmentFilter[] = []
    equipmentTireConfigs: EquipmentTireConfig[] = []

    constructor() {
        super()
        this.refresh()
    }

    refresh() {
        this.cancelableRequest(
            '',
            true,
            this.services.data
                .load(
                    true,
                    true,
                    this.services.data.equipmentFluidCapacities.queryAll(),
                    this.services.data.equipmentGets.queryAll(),
                    this.services.data.equipmentBatteries.queryAll(),
                    this.services.data.equipmentBrakes.queryAll(),
                    this.services.data.equipmentFilters.queryAll(),
                    this.services.data.equipmentTireConfigs.queryAll(),
                    this.services.data.get<VpEquipmentRow[]>('api/VpEquipment'),
                )
                .subscribe({
                    next: result => {
                        this.initialLoadingComplete()
                        this.fluidCapacities = result[0]
                        this.equipmentGets = result[1]
                        this.equipmentBatteries = result[2]
                        this.equipmentBrakes = result[3]
                        this.equipmentFilters = result[4]
                        this.equipmentTireConfigs = result[5]
                        const lookup = buildEquipmentLookup(result[6] ?? [])
                        this.equipmentOptions = lookup.equipmentOptions
                        this.equipmentDataMap = lookup.equipmentDataMap
                        this.equipmentDisplayByCode = lookup.equipmentDisplayByCode
                    },
                }),
        )
    }

    get canEdit() {
        return this.services.authentication.hasFeature([FeatureType.EquipmentPartsFluidsEdit])
    }

    get equipmentContext(): PartsFluidsEquipmentContext {
        return this
    }

    equipmentDisplay(code: string | null | undefined): string {
        return formatEquipmentDisplay(code, this.equipmentDisplayByCode)
    }

    tabChanged() {
        setTimeout(() => {
            window.dispatchEvent(new Event('resize'))
        }, 50)
    }
}
